import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    itcReconciliation: {
      adv_search: null
    }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
